import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import ReadMoreReact from 'read-more-react';


/* Import the images */
import img1 from "../images/about-us/PHOTO DR DHAARNA.png";
import img2 from "../images/about-us/V R Mehta.jpg";
import img3 from "../images/about-us/Prof Asha Hingar.jpg";
import img4 from "../images/about-us/Lakshman Ventakaswami.jpg";
import img5 from "../images/about-us/about-us-poster.png";
import Logo from '../images/about-us/logo.png';
import tm2 from '../images/about-us/tm2.png';

/* Import custom modules*/
import Layout from '../components/layout'
import SEO from "../components/seo"
import ContactForm from '../components/Custom Modules/ContactForm';

/* importing icons */
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none',
    color: '#424242',
    margin: 'auto',
    maxWidth: 800,
    marginTop: '30px',
    marginBottom: '30px'
  },
  paper1: {
    padding: theme.spacing(2),
    boxShadow: 'none',
    color: '#424242',
    margin: 'auto',
    maxWidth: 300,
    marginTop: '10px',
    marginBottom: '30px',
    textAlign: 'left'
  },
  root1: {
    maxWidth: 345,
  },
  roundImg:{
    height: '295px',
    marginBottom: '10px',
    borderRadius: '100%'
  },
  socialMediaIcons:{
      fontSize:30,
      color:'#003a4d',
      marginRight: 16,
      cursor: 'pointer'
  },
  profIntro:{
    marginBottom:'80px'
  },
  poster:{
    width: 600,
    height:600,
  },
  posterContainer:{
    marginTop: 50,
    textAlign: 'center',
  },
  bodyDesciption:{
    marginTop: 30
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 10
  }
}));

const minimumLength = 150;
const idealLength = 200;
const maxLength = 250;

export default function AboutUs() {
  const classes = useStyles();

  return (
    <Layout>
      <SEO
        title={"About Pratiiti.com"}
        description={"Know more about Pratiiti"}
        canonical={"https://wwww.pratiiti.in/about-us"}
      />
      <div>
        <div className={classes.root}>
        <Grid xs={12} md={6} sm={3}>
          <div className="logo">
            <img src={Logo} alt="About US"/>
          </div>
        </Grid>

      <Grid item xs={12}>
        <div className={classes.paper1}>
            <h2 style={{textAlign: 'center'}}>
                Our Story
            </h2>
        </div>
      </Grid>
      
      <Grid container>   
        <Grid item xs={12} sm={6} className={classes.paper}>
          <img className={classes.img} style={{marginTop:'30px'}} src={img5} alt="about-us-poster" />
        </Grid>
    
        <Grid item xs={12} sm={6} className={classes.paper}>
          <div className={classes.bodyDesciption}>
            <div style={{fontSize: 20}}>
            <p>
            I, <strong>Pratiiti</strong>, intrigue your mind. 
            Some of you are very true upto an extent when you correlate with Prtiit means Aabhas, 
            but I’m unique & different. I represent <strong>Vishwas</strong> i.e. 
            <strong>confidence</strong>. 
            Yes, I do represent the Phoenix, from classical mythology, a unique 
            bird of Arabian desert that burned itself on a funeral pyre every 
            five or six centuries and rose from the ashes with renewed youth. 
            Yes, I do represent the ‘resilience’ – the most important factor in 
            life for sustenance. This resilience is the state of mind and rotates 
            and/or revolves around Psychology of each human being. History will 
            corroborate that societies have survived because of resilience only.
            </p>

            <p>
            <strong>Pratiiti Luminaries</strong> promises to put best efforts to 
            luminate your own confidence. 
            We believe that your internal strength is vital for your sustenance i.e. resilience. 
            We facilitate the human beings to achieve confidence so that they can achieve the goal 
            of happiness in life. That’s why our catchphrase or slogan resonates our values – 
            <strong>“Belief in the power of self”</strong>. We try to be truly global by 
            acknowledging the 
            existence of different mythologies across the world. We would like to play the 
            role of Jamwant – from Hindu philosophy – who reminded Hanumanji his hidden 
            powers which would help him cross the ocean in single leap.
            </p>

            <p>
            The brain & colourful internal parts in the design reflects multiple thoughts. 
            The ripples in white around the brain & thoughts depicts our endeavours, through 
            which, farther one travels achieves calm, compose & tranquillity – again 
            the bedrock of happy life.
            </p>
            </div>
          </div>  
        </Grid>
      </Grid>

    <Divider variant="middle" light/>

    <Grid item xs={12}>
        <div className={classes.paper1}>
            <h2 style={{textAlign: 'center'}}>
                Our Vision
            </h2>
        </div>
    </Grid>

    <Grid container>
        <Grid item xs={12}>
            <div className={classes.paper}>
                <h3 style={{fontSize:24}}>
                    Pratiiti will be recognized as a prominent contributor in career development, 
                    mental health and well-being as a sociopreneur. We are committed to a diverse, 
                    confidential, dynamic, cutting-edge approach to each of our services in 
                    counselling, training and comprehensive psychotherapeutic services.
                </h3>
            </div>
        </Grid>
      </Grid>
      
      <Divider variant="middle" light/>

    <Grid item xs={12}>
        <div className={classes.paper1}>
            <h2 style={{textAlign: 'center'}}>
                Our Team
            </h2>
        </div>
    </Grid>

    <Grid container style={{textAlign: 'center', justifyContent: 'space-evenly'}}>
        <Grid item md={4}>
            <img src={img1} alt={img1} className={classes.roundImg} />
            <h3 style={{fontSize:24}}>Dr. Dhaarna Bhardwaj</h3>
            <h4 style={{fontSize:20}}>Founder & Director</h4>
            <div className={classes.paper1}>
            Dr. Dhaarna Bhardwaj has a rich experience of over 20 years in the counseling 
            domain and has established herself as a career counselor, life skills trainer, 
            counselor, coach as well as an expert psychotherapist.
            <div style={{marginTop:10}}>
                <a href="https://www.facebook.com/dhaarna.bhardwaj" target="_blank" rel="noopener noreferrer"><FacebookIcon className={classes.socialMediaIcons}/></a>
                <a href="https://www.linkedin.com/in/dhaarna-bhardwaj-b36102148/" target="_blank" rel="noopener noreferrer"><LinkedInIcon className={classes.socialMediaIcons}/></a>
            </div>
          </div>
        </Grid>
    </Grid>

    <Grid container style={{textAlign: 'center', justifyContent: 'space-evenly'}}>
        <Grid item md={4}>
            <img src={tm2} alt={'team member 2'} className={classes.roundImg} />
            <h3 style={{fontSize:22}}>Anushka Mehta</h3>
            <h4 style={{fontSize:16}}>Mental Wellness Intern</h4>
            <div className={classes.paper1}>
            A Psychology student with a deep appreciation and interest in art and psychology.  
            She uses these disciplines as an outlet to convey her deep thoughts and ideas in a unique way. 
            She loves fine arts and design  spending hours sketching the most trivial things in the universe. 
            She has had an art exhibition at the India Habitat Canter and also delivered a Ted-Ed Talk on “Art An expression”, 
            divulging in the entrancing relationship between art and emotions. She is also write articles on 
            diverse topics to spread awareness, hoping to leave an impact.
          </div>
        </Grid>
    </Grid>

    <Divider variant="middle" light/>

    <Grid item xs={12}>
        <div className={classes.paper1}>
            <h2 style={{textAlign: 'center', marginTop:'20px'}}>
                Our Mentors
            </h2>
        </div>
    </Grid>

        <Grid container className={classes.profIntro} justify="center" alignItems="center">
          <Grid xs={12} sm={12} md={3} style={{textAlign: 'center', justifyContent: 'space-evenly'}}>
            <img src={img2} alt={img1} className={classes.roundImg} />
            <h4>Prof. V R Mehta</h4>
          </Grid>
          <Grid xs={12} sm={12} md={6} style={{textAlign: 'center', justifyContent: 'space-evenly', marginTop: 30}}>
            <ReadMoreReact 
                text={
                  "Prof. V. R. Mehta is an illustrious academician of Political Science, Ex-VC of Delhi University, an internationally acclaimed prolific writer and chief mentor of FAEA.  He has won several national and international awards and is an aluminus of Delhi University and Cambridge (U.K.)."
                  +"Prof. Vrajendra Raj Mehta, Ph.D. (Cantab) is the member secretary of the Foundation for Academic Excellence and Access (FAEA). He is also the Vice-Chairman of the Executive committee of the Nehru Memorial Museum and Library. Prof. Mehta was earlier Vice-Chancellor of University of Delhi (1995-2000). He was educated at the Universities of Delhi and Cambridge (U.K.). He began his academic career as a Lecturer in Political Science in Delhi. He was later appointed Associate Professor at Himachal Pradesh University and today has the distinction of being a University Professor of over twenty seven years standing. He also became Dean, Faculty of Arts and Social Sciences and a Member of the Executive Council at the Himachal Pradesh University. In 1978 he was invited to become a Professor in the Department of Political Science, Rajasthan University, Jaipur. He was also Head of the Department of Political Science, Coordinator of UGC sponsored ULP Programme in Political Science, RajasthanUniversity, Hon. Director of the Centre of Gandhian Studies, University of Rajasthan. Besides being Professor of Political Science, he was also director of the Institute of Correspondence Studies, University of Rajasthan, Jaipur. He was also Chief Warden, Rajasthan University for two years. Professor Mehta was the First Vice-Chancellor of Kota Open University from 1987 to 1990. "}
                min={minimumLength}
                ideal={idealLength}
                max={maxLength}
                readMoreText="read more..."
            />
          </Grid>  
        </Grid>

        <Grid container className={classes.profIntro} justify="center" alignItems="center">
          <Grid xs={12} sm={12} md={3} style={{textAlign: 'center', justifyContent: 'space-evenly'}}>
            <img src={img3} alt={img1} className={classes.roundImg} />
            <h4>Prof. Asha Hingar</h4>
          </Grid>
          <Grid xs={12} sm={12} md={6} style={{textAlign: 'center', justifyContent: 'space-evenly', marginTop: 30}}>        
            <ReadMoreReact 
                text={"Professor Asha Hingar is a stalwart in the field of psychology.  She has a prolific experience of over four decades in teaching, administration and research in University of Rajasthan.  She has guided more than 60 students for Ph. D and M.Phil. She has directed various training programs and trained many counsellors under her able guidance. She has authored many books and contributed chapters to many book written by renowned professionals.  Hundreds of articles by her have been published in indexed Indian Journals.  Apart from presenting numerous papers and chairing various national conferences she has held various positions including Director, Student Advisory Bureau, Department of Adult and Continuing Education, University of Rajasthan amongst others."}
                min={minimumLength}
                ideal={idealLength}
                max={maxLength}
                readMoreText="read more..."
            />
          </Grid>  
        </Grid>

        <Grid container className={classes.profIntro} justify="center" alignItems="center"> 
          <Grid xs={12} sm={12} md={3} style={{textAlign: 'center', justifyContent: 'space-evenly'}}>
            <img src={img4} alt={img1} className={classes.roundImg} />
            <h4>Dr. L. V. Reddy</h4>
          </Grid>
          <Grid xs={12} sm={12} md={6} style={{textAlign: 'center', justifyContent: 'space-evenly', marginTop: 30}}>
            <ReadMoreReact 
                text={"Dr. Lakshman Ventakaswami Reddy is a stalwart in the field of training and career guidance. MA psychology, M.Ed., MA (Distance Education), Post Grad Diploma in EVG (Educational and Vocational guidance, NCERT), Ph.D. and did his Post Doctrate in Career Counselling.  Advisory Board Member National Talent Search examination (NTSE), Government of Karnataka, Ex National Committee member, Rehabilitation Council of India. He started as a Teacher educator at B.Ed. Level and was appointed as a State Psychologist of Karnataka Government. He got selected through UPSC as a Training Officer in Ministry of Labour & Employment, GOI.  He became Senior Research Officer, (Occupational Research) and later on was promoted as a Deputy Director & Head, Career Study Centre and later headed the Career Study Centre as a Director & HOD.  Dr. Reddy is an eminent scholar and has presented 250 papers at State, National & International levels. Dr. Reddy has contributed immensely in the field of career counselling and more than 200 booklets on various careers have been published.  He also has been associated with working of NCO 2004. Dr. Reddy has been awarded the International Labour Organization Fellowship.  He is a Master Trainer for Entrepreneurial Motivation Training, he has contributed immensely towards training of the counsellors and teachers in all the RIEs under NCERT.  He is a core Faculty in NCERT.  He is a National Accredited Trainer- DOPT (Department of Personnel Training)."}
                min={minimumLength}
                ideal={idealLength}
                max={maxLength}
                readMoreText="read more..."
            />
          </Grid> 
        </Grid>

    </div>
    <ContactForm/>
    </div>
    </Layout>
  );
}
